/*
 * @Author: Tina Huang
 * @Date: 2024-02-20 09:35:54
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 16:08:37
 * @Description:
 */
import { useState, useMemo, useEffect } from 'react'
import { PickType, Picks as picks } from '@/constants/picks'
import { LIVE_TYPE, lives } from '@/constants/lives'
import type { RadioChangeEvent } from 'antd'
import { Avatar, Button, Checkbox, Flex, Input, Radio, Result, Tag } from 'antd'
import PickList from './components/picks-list'
import LivesList from './components/lives-list'
import { useParams } from 'react-router-dom'
import FreeIcon from '@/assets/svgs/free'
import { SearchOutlined } from '@ant-design/icons'
// import LibItem from './components/Items'
import { notifies } from '@/constants/notifies'

export default function Picks(props: { __type?: string } = { __type: 'default' }) {
  const [type, setType] = useState('pick')
  const { __type } = props
  const isMobile = window.innerWidth <= 750
  const { tab } = useParams()
  // const navigate = useNavigate()
  const [keywords, setKeywords] = useState('')
  const [isShowFree, setIsShowFree] = useState(false)
  const [isShowSearch, setIsShowSearch] = useState(false)

  useEffect(() => {
    tab && setType(tab as any)
  }, [tab])

  const handleChange = (e: RadioChangeEvent) => {
    const _type = e.target.value
    setType(_type)
    // setKeywords('')
  }

  const onSearch = (keywords: string) => {
    setIsShowSearch(false)
    setKeywords(keywords)
    // navigate(`/search/${keywords}`)
  }

  const onShowFree = (e: any) => {
    const value = e.target.checked
    setIsShowFree(value)
  }

  const isSearchResult = (item: PickType, key: string, isShowFree: boolean) => {
    const l = [
      item?.title?.indexOf(key) > -1,
      item.full_title && item?.full_title?.indexOf(key) > -1,
      item?.detail && item?.detail?.indexOf(key) > -1,
      item?.description && item?.description?.indexOf(key) > -1,
    ]
    return l.filter((current) => current).length > 0 && (isShowFree ? !item.pay : true)
  }

  const libsList: PickType[] | LIVE_TYPE[] = useMemo(() => {
    const _picks = picks.filter((item) => isSearchResult(item, keywords, isShowFree))
    if (_picks.length <= 0) return []
    if (type === 'pick') return _picks.filter((item) => !item.hide && !item.top && !item.flowus)
    if (type === 'live') return lives
    if (type === 'flowus') return _picks.filter((item) => !item.hide && !item.top && item.flowus)
    return []
  }, [type, keywords, isShowFree])

  const lists = useMemo(() => {
    const __top = notifies.find((item) => !item.hide) ? [{ title: '重要通知' }] : []
    if (type === 'pick' || type === 'flowus') {
      const _l4 = (libsList as PickType[]).filter((item: any) => item.id % 4 === 3)
      const _l3 = (libsList as PickType[]).filter((item: any) => item.id % 4 === 2)
      const _l2 = (libsList as PickType[]).filter((item: any) => item.id % 4 === 1)
      const _l1 = (libsList as PickType[]).filter((item: any) => item.id % 4 === 0)
      // const __top = picks.filter((item) => !item.hide && item.top)
      return [[...__top, ..._l1], _l2, _l3, _l4]
    } else {
      return [__top, libsList]
    }
  }, [libsList, type])

  const handleMobileMenuClick = (key: string) => {
    console.log(key)
    setKeywords('')
    setType(key)
  }

  const MobileMenuItem = (props: any) => {
    const { type, name, value, needPadding = true } = props
    return (
      <span
        onClick={() => handleMobileMenuClick(value)}
        className={`${needPadding ? 'pr-4' : ''} ${type === value ? 'font-bold text-blue-500' : ''}`}
      >
        {name}
      </span>
    )
  }

  const pageFlexProps = isMobile
    ? {
        vertical: true,
        gap: 'middle',
        justify: 'center',
        align: 'center',
      }
    : {
        gap: 'middle',
        justify: 'center',
        align: 'center',
      }

  return (
    <>
      {!isMobile && (
        <Flex {...pageFlexProps}>
          {__type !== 'vip' && !isMobile && (
            <Radio.Group onChange={handleChange} defaultValue={type} value={type} size="large" buttonStyle="solid">
              <Radio.Button value="pick">
                <Avatar className="w-5 h-5 mr-1" src="./assets/logos/notion-logo.png" /> {!isMobile && 'Notion 模板'}
              </Radio.Button>
              <Radio.Button value="flowus">
                <Avatar className="w-5 h-5 mr-1" src="./assets/logos/flowus2.png" />
                {!isMobile && 'FlowUs 模板'}
              </Radio.Button>
              <Radio.Button value="live">📁 {!isMobile && '教程系列'}</Radio.Button>
            </Radio.Group>
          )}
          {__type === 'vip' && (
            <h1 className="text-3xl font-bold flex items-center">
              <Tag className="text-xl" color="volcano">
                会员专享
              </Tag>{' '}
              ✨ 模板更新库 ✨
            </h1>
          )}
          {!isMobile && (
            <>
              <Input.Search className="w-56" size="large" onSearch={onSearch} enterButton placeholder="🔍 搜索模版" allowClear />

              <Checkbox value={isShowFree} onChange={onShowFree}>
                只看免费模版
              </Checkbox>
            </>
          )}
          {/* {isMobile && <Input.Search className="w-full" size="large" onSearch={onSearch} enterButton placeholder="🔍 搜索模版" allowClear />} */}
        </Flex>
      )}
      {isMobile && (
        <div className="fixed bg-white w-full p-4 z-100" style={{ marginLeft: '-0.75rem', marginTop: '-0.75rem' }}>
          <Flex justify="space-between">
            <FreeIcon checked={isShowFree} onClick={() => setIsShowFree(!isShowFree)} />

            <Flex className="w-3/4" justify="center">
              <MobileMenuItem type={type} name="Notion" value="pick" />
              <MobileMenuItem type={type} name="FlowUs" value="flowus" />
              <MobileMenuItem type={type} name="教程" value="live" needPadding={false} />
            </Flex>
            <SearchOutlined onClick={() => setIsShowSearch(true)} style={{ fontSize: 20, color: isShowSearch ? 'white' : '' }} />
          </Flex>
          {isShowSearch && (
            <Input.Search
              className="w-full mt-2"
              size="large"
              // onChange={(e) => onSearch(e.target.value)}
              onSearch={onSearch}
              enterButton
              placeholder="🔍 搜索模版"
              allowClear
            />
          )}
        </div>
      )}
      <div style={{ marginTop: isMobile ? 12 : 0, marginLeft: isMobile ? '-0.2rem' : '', marginRight: isMobile ? '-0.2rem' : '' }}>
        {libsList.length <= 0 && (
          <Result
            status="404"
            title={`暂无符合[${keywords}]条件的模版`}
            subTitle="若有相关模版需求可在右下角问题反馈进行反馈"
            extra={
              <Button type="primary" onClick={() => setKeywords('')}>
                查看全部模版
              </Button>
            }
          />
        )}
        {type === 'pick' && <PickList lists={lists} originList={libsList} pickType={type} __type={__type} />}
        {type === 'flowus' && <PickList lists={lists} originList={libsList} pickType={type} __type={__type} />}
        {type === 'live' && <LivesList lists={lists} originList={libsList} />}
      </div>
    </>
  )
}
